import { Grid, IconButton } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../../../../common/constants/apiUrl";
import DeleteIcon from "@material-ui/icons/HighlightOffSharp";

interface IProps {
  fileName: string;
  openDeleteDialog: (fileName: string) => void;
}

const ExhibitImage: React.FC<IProps> = ({ fileName, openDeleteDialog }) => {
  const [logo, setLogo] = useState(
    "Please select a valid file type (png/jpg/jpeg)."
  );

  useEffect(() => {
    setLogo(`${apiUrl}/exhibits/thumbnail/${fileName}`);
  }, [fileName]);

  return (
    <Grid
      item
      style={{
        position: "relative",
      }}
    >
      <IconButton
        aria-label="Delete"
        onClick={() => {
          openDeleteDialog(fileName);
        }}
        style={{
          position: "absolute",
          right: 0,
          backgroundColor: "#1212128c",
          color: "white",
          padding: "5px",
          zIndex: 10,
        }}
      >
        <DeleteIcon />
      </IconButton>
      <img src={logo} alt="Exhibit thumnail" width="300px" />
    </Grid>
  );
};

export default ExhibitImage;
